import { useEcomStore } from '@/data';
import { useData, useStoreGateRedirect } from '@/components';

const useDeepLinkStore = () => {
  const [, setStoredState] = useEcomStore();
  const { treezStores } = useData();
  const gateAndRedirect = useStoreGateRedirect();

  const deepLinkStore = (storeName?: string) => {
    if (!storeName) return;

    const validStore = treezStores?.some(
      store => store?.short_name === storeName,
    );

    if (!validStore) return;

    if (
      gateAndRedirect(storeName, {
        next_store_id: storeName,
        next_shop_mode: 'pickup',
      })
    ) {
      return;
    }

    setStoredState({
      delivery_details: {
        delivery: false,
        pickup: true,
      },
      treez_store_name: storeName,
    });
  };

  return { deepLinkStore };
};

export { useDeepLinkStore };
